import { useState, useEffect } from 'react';
import { cachedFetch } from '../utils/api_cache';
import getEnv from '../env';

const API_URL = getEnv('REACT_APP_API_URL') || 'http://localhost:8000';

/**
 * Whether a person entity belongs to one of this node's super admins — backs
 * the "node admin" badge on a profile. Unlike useIsAdmin (is the *viewer* an
 * admin of this entity?), this is about the profile's owner, so every viewer
 * gets the same answer.
 *
 * @param {number|string} entityId
 * @param {boolean} enabled  only ask for local person entities
 * @returns {boolean}
 */
function useIsNodeAdmin(entityId, enabled) {
    const [isNodeAdmin, setIsNodeAdmin] = useState(false);

    useEffect(() => {
        setIsNodeAdmin(false);
        if (!entityId || !enabled) return;

        let cancelled = false;
        cachedFetch(`${API_URL}/api/entities/${entityId}/node-admin`)
            .then(data => { if (!cancelled) setIsNodeAdmin(data.is_node_admin === true); })
            .catch(() => {}); // badge is cosmetic — a failed check just leaves it off
        return () => { cancelled = true; };
    }, [entityId, enabled]);

    return isNodeAdmin;
}

export default useIsNodeAdmin;
